import {twx} from '../../../utils/tailwindUtils';
import Icon from '../Icon';

const DeviceIcon = ({isActive, ...rest}) => {
    return (
        <Icon width='25' height='24' fill='none' {...rest}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.11174 22.0004C7.81795 22.0008 7.52698 21.9442 7.25555 21.8338C6.98413 21.7235 6.73759 21.5616 6.53012 21.3575C6.32211 21.1539 6.15715 20.9119 6.04473 20.6455C5.9323 20.3792 5.87462 20.0936 5.875 19.8053V6.14675C5.87474 6.05059 5.89385 5.95532 5.93122 5.86643C5.9686 5.77754 6.02351 5.69678 6.09279 5.62878C6.16208 5.56078 6.24437 5.5069 6.33495 5.47022C6.42553 5.43353 6.5226 5.41478 6.62058 5.41504H9.6029C10.6328 5.41504 11.5643 5.8248 12.2393 6.48626C12.5859 6.82567 12.8608 7.22898 13.0482 7.673C13.2355 8.11702 13.3315 8.593 13.3308 9.07358V22.0004H8.11174Z'
                className={isActive ? 'stroke-color-primary' : 'stroke-color-primary dark:stroke-color-secondary'}
                strokeWidth={isActive ? '1.5' : '1.17'}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M13.6618 22C13.3682 22.0002 13.0774 21.9436 12.8062 21.8332C12.5349 21.7229 12.2885 21.5611 12.0812 21.3571C11.8728 21.1536 11.7075 20.9117 11.5947 20.6454C11.4819 20.379 11.424 20.0933 11.4241 19.8049V2.34146L15.649 2C16.8161 2 17.8718 2.46439 18.6373 3.21463C19.0302 3.5992 19.3418 4.05617 19.5542 4.55929C19.7666 5.06241 19.8756 5.60175 19.875 6.14634V21.7561L13.6618 22Z'
                className={twx(
                    isActive
                        ? 'fill-[#B2F1F1] stroke-color-primary dark:fill-[#B2F1F1]'
                        : 'fill-color-secondary stroke-color-primary dark:fill-[#3E3A46] dark:stroke-color-secondary' // Fix for overlapping paths in the icon
                )}
                strokeWidth={isActive ? '1.5' : '1.17'}
            />
        </Icon>
    );
};

export default DeviceIcon;
